var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',[_c('navMenu'),_c('el-main',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }